// Helper para construir URLs de API consistentemente
const buildApiUrl = (
  endpoint,
  {
    hostname = (typeof window !== 'undefined' ? window.location.hostname : ''),
    envBaseUrl = process.env.REACT_APP_API_BASE_URL
  } = {}
) => {
  const isLocalHost = ['localhost', '127.0.0.1'].includes(hostname);
  const isTunnelHost = typeof hostname === 'string' && hostname.endsWith('.trycloudflare.com');

  // Definir la URL base según el host real de ejecución
  let baseUrl;

  if (isLocalHost) {
    baseUrl = 'http://localhost/diegoncurso/api';
  } else if (isTunnelHost) {
    // Build servido vía túnel Cloudflare como respaldo local (ver DEPLOY_PUBLIC_HTML.txt)
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    baseUrl = `${origin}/concurso-local/api`;
  } else {
    // En producción, usar la variable de entorno o la URL pública
    baseUrl = envBaseUrl || 'https://www.diegoncurso.es/api';
  }

  // Normalizar la URL base (asegurar que no termine con / salvo que sea solo "/")
  const normalizedBaseUrl = baseUrl === '/' ? baseUrl : baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  // Asegurar que el endpoint comience con /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${normalizedBaseUrl}${normalizedEndpoint}`;
};

export default buildApiUrl;
